<template>
  <div class="priceboost priceboost--no-shirt promo-container">
    <div class="event-content">
      <div class="title">
        {{ scContent.FieldValues.Title }}
      </div>
      <div class="event">
        <div class="event__claim" v-html="scContent.FieldValues.Parameters['copy_claim']"></div>
      </div>
      <div class="event-odds">
        <div class="event-odds__was">
          <span class="event-odds__label">{{ scContent.FieldValues.Parameters['copy_was-label'] }}</span>
          <span class="event-odds__value">{{ event.Event.Market.Option[priceboostSelection]['@odds'] }}</span>
        </div>
        <a class="event-odds__now" :href="betSlipUrl">
          <span class="event-odds__label">{{ scContent.FieldValues.Parameters['copy_now-label'] }}</span>
          <span class="event-odds__value">{{ scContent.FieldValues.Parameters['copy_now-odds'] }}</span>
        </a>
      </div>
      <div class="event-text" v-html="scContent.FieldValues.Text"></div>
      <div
        v-if="!loggedin"
        class="event-cta"
      >
        <a class="button button--cta button--md" :href="scContent.FieldValues.Parameters['link_cta']">{{ scContent.FieldValues.Parameters['copy_cta'] }}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'scContent',
    'betSlipUrl',
    'teamShirts',
    'event',
    'eventDate',
    'priceboostSelection',
    'loggedin'
  ],
  mounted() {},
};
</script>

<style lang="scss">
.priceboost--no-shirt {
  @media (min-width: 991px) {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
  }
  @media (min-width: 991px) {
    .event-content {
      position: relative;
      background-color: transparent;
      margin-top: 0;
    }
  }
}
</style>
